// extracted by mini-css-extract-plugin
module.exports = {"item":"Articles_item__ht7L7","links":"Articles_links__04kMd"};